import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/global.css'
import AppIcon from './components/AppIcon.vue'

const app = createApp(App)
app.use(store)
app.use(router)
app.component('AppIcon', AppIcon)
app.mount('#app')
